<template>
  <span class="inline-block-component"><slot /></span>
</template>

<script setup>
defineOptions({ inheritAttrs: false });
</script>

<style scoped lang="scss" type="text/scss">
  .inline-block-component + .inline-block-component {
    display: block;
    margin-top: .6rem;
  }
</style>
